/**
 * CAPSULE - Mobile Responsive JavaScript
 * Système "Lire la suite" avec troncature après 10 lignes
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    maxLinesDescription: 15,
    maxLinesIntervenant: 10,
    maxLinesProgramme: 10,
    minLinesProgramme: 20,
    breakpoint: 768,
    selectors: {
      description: '#description .smi-format-content, .smi-product-block-description .smi-format-content, .smi-text-md.smi-format-content.smi-color-text-75',
      intervenant: '#intervenant .smi-format-content',
      programme: '#programme .smi-format-content',
      objectifs: '#objectifs .smi-format-content'
    },
    texts: {
      readMore: 'Lire la suite',
      readLess: 'Réduire'
    }
  };

  // Icône SVG flèche
  const arrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>`;

  /**
   * Vérifie si on est sur mobile
   */
  function isMobile() {
    return window.innerWidth <= CONFIG.breakpoint;
  }

  /**
   * Calcule la hauteur pour N lignes
   */
  function getLineHeight(element) {
    const style = window.getComputedStyle(element);
    const lineHeight = parseFloat(style.lineHeight);
    const fontSize = parseFloat(style.fontSize);
    
    // Si lineHeight est "normal", estimer à 1.6 * fontSize
    if (isNaN(lineHeight)) {
      return fontSize * 1.6;
    }
    return lineHeight;
  }

  /**
   * Vérifie si le contenu dépasse N lignes
   */
  function exceedsMaxLines(element, maxLines) {
    const lineHeight = getLineHeight(element);
    const maxHeight = lineHeight * maxLines;
    const actualHeight = element.scrollHeight;
    
    return actualHeight > maxHeight + 20; // Marge de 20px
  }

  /**
   * Crée le bouton "Lire la suite"
   */
  function createReadMoreButton() {
    const button = document.createElement('button');
    button.className = 'caps-read-more-btn';
    button.type = 'button';
    button.innerHTML = `<span>${CONFIG.texts.readMore}</span>${arrowIcon}`;
    button.setAttribute('aria-expanded', 'false');
    return button;
  }

  /**
   * Initialise la troncature sur un élément
   */
  function initTruncation(element, maxLines) {
    // Éviter la double initialisation
    if (element.dataset.capsInitialized) return;
    element.dataset.capsInitialized = 'true';
    
    // Utiliser le nombre de lignes passé en paramètre ou la valeur par défaut
    const linesToShow = maxLines || CONFIG.maxLines;

    // Créer le wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'caps-truncate-description';
    wrapper.dataset.maxLines = linesToShow;
    
    // Créer le container de contenu
    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'caps-truncate-content';
    
    // Déplacer le contenu dans le wrapper
    element.parentNode.insertBefore(wrapper, element);
    contentWrapper.appendChild(element);
    wrapper.appendChild(contentWrapper);
    
    // Vérifier si troncature nécessaire
    if (exceedsMaxLines(element, linesToShow)) {
      wrapper.classList.add('is-truncated');
      
      // Créer et ajouter le bouton
      const button = createReadMoreButton();
      wrapper.appendChild(button);
      
      // Gestionnaire de clic
      button.addEventListener('click', function() {
        const isExpanded = wrapper.classList.contains('is-expanded');
        
        if (isExpanded) {
          wrapper.classList.remove('is-expanded');
          wrapper.classList.add('is-truncated');
          button.innerHTML = `<span>${CONFIG.texts.readMore}</span>${arrowIcon}`;
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('is-expanded');
          
          // Scroll vers le haut du bloc
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          wrapper.classList.remove('is-truncated');
          wrapper.classList.add('is-expanded');
          button.innerHTML = `<span>${CONFIG.texts.readLess}</span>${arrowIcon}`;
          button.setAttribute('aria-expanded', 'true');
          button.classList.add('is-expanded');
        }
      });
    }
  }

  /**
   * Réinitialise la troncature (pour resize)
   */
  function resetTruncation(wrapper) {
    const content = wrapper.querySelector('.caps-truncate-content');
    const element = content ? content.firstElementChild : null;
    const button = wrapper.querySelector('.caps-read-more-btn');
    
    if (!element) return;
    
    // Utiliser le maxLines stocké dans le wrapper
    const maxLines = parseInt(wrapper.dataset.maxLines) || CONFIG.maxLines;
    
    if (isMobile() && exceedsMaxLines(element, maxLines)) {
      wrapper.classList.add('is-truncated');
      if (button) button.style.display = '';
    } else {
      wrapper.classList.remove('is-truncated', 'is-expanded');
      if (button) button.style.display = 'none';
    }
  }

  /**
   * Initialise tous les blocs description
   * DÉSACTIVÉ - Le système "Lire la suite" est désactivé
   */
  function init() {
    return; // DÉSACTIVÉ
    if (!isMobile()) return;

    // Description : 15 lignes
    document.querySelectorAll(CONFIG.selectors.description).forEach(function(element) {
      if (element.textContent.trim().length > 200) {
        initTruncation(element, CONFIG.maxLinesDescription);
      }
    });
    
    // Intervenant : 10 lignes
    document.querySelectorAll(CONFIG.selectors.intervenant).forEach(function(element) {
      if (element.textContent.trim().length > 150) {
        initTruncation(element, CONFIG.maxLinesIntervenant);
      }
    });
    
    // Programme : 10 lignes seulement si le texte fait au moins 20 lignes
    document.querySelectorAll(CONFIG.selectors.programme).forEach(function(element) {
      if (exceedsMaxLines(element, CONFIG.minLinesProgramme)) {
        initTruncation(element, CONFIG.maxLinesProgramme);
      }
    });
    
    // Objectifs : 10 lignes
    document.querySelectorAll(CONFIG.selectors.objectifs).forEach(function(element) {
      if (element.textContent.trim().length > 200) {
        initTruncation(element, CONFIG.maxLinesProgramme);
      }
    });
  }

  /**
   * Gestion du resize
   */
  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const wrappers = document.querySelectorAll('.caps-truncate-description');
      wrappers.forEach(resetTruncation);
    }, 250);
  }

  // Initialisation au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Gestion du resize
  window.addEventListener('resize', handleResize);

  // Réinitialiser si le contenu change (Shopify sections)
  document.addEventListener('shopify:section:load', init);

})();

